import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=5cfd4d58&scoped=true"
import script from "./RequestDetail.vue?vue&type=script&lang=js"
export * from "./RequestDetail.vue?vue&type=script&lang=js"
import style0 from "./RequestDetail.vue?vue&type=style&index=0&id=5cfd4d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd4d58",
  null
  
)

export default component.exports